import { IsiGridView } from "../../IsiWebGUI/IsiFW/Components/Grid/IsiGridView";
import { IIsiBeforeSaveResult, ISavingCustomBehaviour } from "../../IsiWebGUI/IsiFW/Components/Grid/Saver/ISavingCustomBehaviour";
import { IsiIWSAssociatedView } from "../GridView/AssociatedView/IsiAssociatedView";
import { modifWaitStatus } from "../../IsiPage.ts";
import { SaveMode } from "../../Dtos/Isilog.IsiFramework.IsiDataTransferObject.IsiGrid";


export class IsiIwsGridSavingBehaviour implements ISavingCustomBehaviour {

    private _assView: IsiIWSAssociatedView;
    private _gridView: IsiGridView;

    constructor(gridView: IsiGridView, assView: IsiIWSAssociatedView) {
        this._gridView = gridView;
        this._assView = assView;
    }

    /**
     Méthode appellé dans le cas d'une sauvegarde fructueuse.
    */
    public successHandler(data: any, flow: IIsiBeforeSaveResult) {

        modifWaitStatus(false, false, window.sCodeLibelleStatus);

        this._assView.changeValidationState(false);

        //en enregistrement explicit on veut refresh la grille
        if (!flow.postBack || this._gridView.getGridSaveMode() === SaveMode.Explicite) {
            this._gridView.refresh();
        }

        if (data.DynamicProperties) {
            this._assView.afterSaveChanges(data.DynamicProperties);
        }
    }

    /**
     Méthode appellé dans le cas d'une sauvegarde infructueuse.
     */
    public errorHandler(jqXHR: any, textStatus: string, errorThrown: string) {

        modifWaitStatus(false, false, window.sCodeLibelleStatus);

        if (jqXHR.responseJSON && jqXHR.responseJSON.ExceptionMessage) {
            this._assView.showSaveChangesError(jqXHR.responseJSON.ExceptionMessage);
        }
    }

    /**
     * Appelée avant la sauvegarde
     */
    public beforeSave(updatedRows: any): Promise<IIsiBeforeSaveResult> {
        return new Promise<IIsiBeforeSaveResult>((resolve, reject) => {

            uiCore.setLoadInProgress;

            this._assView.beforeValidate(updatedRows).then((flow) => {
                resolve({
                    additionnalInformation: flow.additionnalInformation,
                    cancel: !flow.continue,
                    postBack: flow.postBack,
                    refresh: flow.refresh
                });

            });
        })
    }
}
